/*
 * @Author: Tina Huang
 * @Date: 2024-02-18 17:27:35
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2026-01-29 21:22:47
 * @Description:
 */
type LIB_ITEM_TYPE = {
  id: number
  cover: string
  tag: string
  link: string
  mode?: string
  timestamp?: string
  font_color?: string
  icons?: any[]
  bg_color?: string
  background?: any[]
  dark?: boolean
  extra_link?: string
  color_unset?: boolean
  desc?: string
  monday?: boolean
  size?: string
  theme?: any[]
  hide?: boolean
  close?: boolean
  advance?: boolean
  tags?: string
  expired?: string,
  lng?: string
}

export const defaultItem: LIB_ITEM_TYPE = {
  id: 23,
  cover: './assets/green-calendar.png',
  tag: '插画日历',
  link: '/v3/month-kt.html',
  mode: 'all',
  dark: false,
  monday: true,
  bg_color: '#709a65',
  font_color: '#ffffff',
  color_unset: true,
  timestamp: '1658419200000',
}

export const times: LIB_ITEM_TYPE[] = [
  {
    id: 41,
    cover: './assets/wids/widget-41.png',
    tag: '大数字倒计时',
    link: '/v300/card-countdown.html',
    mode: 'light',
    timestamp: '1769692561122',
    font_color: '#355f5b'
  },
  ///v221/countdown-card.html?name=%E8%80%83%E7%A0%94&day=2024/12/20
  {
    id: 40,
    cover: './assets/wids/widget-40.png',
    tag: '粉红兔兔倒计时',
    link: '/v221/countdown-card.html',
    mode: 'all',
    timestamp: '1722934869546',
  },
  {
    id: 39,
    cover: './assets/wids/widget-39.png',
    tag: '极简倒计时',
    link: '/v230/countdown-p.html',
    mode: 'all',
    timestamp: '1716341147958',
  },
  {
    id: 38,
    cover: './assets/wids/widget-38.png',
    tag: '翻页时钟',
    link: '/v220/rotate-clock.html',
    mode: 'all',
    timestamp: '1690383029742',
  },
  {
    id: 37,
    cover: './assets/wids/widget-37.png',
    tag: '年月日进度条',
    link: '/v220/progress.html',
    mode: 'all',
    timestamp: '1690383029742',
    font_color: '#333',
  },
  {
    id: 36,
    cover: './assets/wids/widget-36.png',
    tag: '极简日期周进度',
    link: '/v220/date.html',
    mode: 'all',
    timestamp: '1690383029742',
    font_color: '#333',
  },
  {
    id: 35,
    cover: './assets/wids/widget-35.png',
    tag: '心情日进度',
    link: '/v220/day-set.html',
    mode: 'all',
    timestamp: '1690383029742',
    icons: [
      { key: 'emoji-1', label: '心累' },
      { key: 'emoji-2', label: '愉悦' },
      { key: 'emoji-3', label: '懵圈' },
      { key: 'emoji-4', label: '困倦' },
      { key: 'emoji-5', label: '开心' },
      { key: 'emoji-6', label: '无语' },
    ],
    bg_color: '#FEC938',
    font_color: '#333333',
  },
  {
    id: 34,
    cover: './assets/wids/widget-34.png',
    tag: 'FlowUs 组件组',
    link: '/v203/mul-days-matter.html',
    mode: 'all',
    timestamp: '1687836037237',
    extra_link: 'https://flowus.cn/httishere/share/2047ba6e-985d-40ba-a1e2-9ec252b66797?promotionChannel=Red_fwj_08',
  },
  {
    id: 33,
    cover: './assets/wids/widget-33.png',
    tag: '极简多项倒计时',
    link: '/v203/mul-days-matter.html',
    mode: 'all',
    timestamp: '1677732750247',
  },
  {
    id: 32,
    cover: './assets/wids/widget-32.JPG',
    tag: 'My days（倒数日&纪念日&正数日）',
    link: '/v203/countdown-card.html',
    bg_color: '#4E6AD9',
    font_color: '#ffffff',
    background: [
      { key: 9, url: './assets/wids-bg/card-bg-9.jpg' },
      { key: 1, url: './assets/wids-bg/card-bg-1.jpg' },
      { key: 2, url: './assets/wids-bg/card-bg-2.jpg' },
      { key: 3, url: './assets/wids-bg/card-bg-3.jpg' },
      { key: 4, url: './assets/wids-bg/card-bg-4.jpg' },
      { key: 5, url: './assets/wids-bg/card-bg-5.jpg' },
      { key: 6, url: './assets/wids-bg/card-bg-6.jpg' },
      { key: 7, url: './assets/wids-bg/card-bg-7.jpg' },
      { key: 8, url: './assets/wids-bg/card-bg-8.jpg' },
      { key: 10, url: './assets/wids-bg/card-bg-10.jpg' },
      { key: 11, url: './assets/wids-bg/card-bg-11.jpg' },
      { key: 12, url: './assets/wids-bg/card-bg-12.jpg' },
      { key: 13, url: './assets/wids-bg/card-bg-13.jpg' },
      { key: 14, url: './assets/wids-bg/card-bg-14.jpg' },
      { key: 15, url: './assets/wids-bg/card-bg-15.jpg' },
      { key: 0 },
    ],
    desc: '插画图片 cr ins：illusbujo，侵删（PS: 需要将背景改为「无背景图」背景色才会生效）',
    size: 'auto',
    mode: 'all',
    hide: false,
    close: false,
    advance: false,
    timestamp: '1675776271295',
  },
  {
    id: 31,
    cover: './assets/wids/widget-31.png',
    tag: '区间进度条',
    link: '/v201/custom-progress.html',
    mode: 'all',
    timestamp: '1674748800000',
  },
  {
    id: 29,
    cover: './assets/widget-29.png',
    tag: '范围日历',
    link: '/calendarByWeek.html',
    mode: 'light',
    timestamp: '1673107200000',
  },
  {
    id: 30,
    cover: './assets/shadow-clock.png',
    tag: '发光数字时钟',
    link: "/v201/e'clock.html",
    mode: 'dark',
    dark: true,
    color_unset: true,
    desc: '参考了其他开源代码样式',
    timestamp: '1671638400000',
  },
  {
    id: 28,
    cover: './assets/days-matter2.png',
    tag: '渐变倒数日',
    link: '/days-matter2.html',
    mode: 'all',
    dark: false,
    color_unset: true,
    timestamp: '1671638400000',
  },
  {
    id: 27,
    cover: './assets/days-matter.png',
    tag: '卡片倒数日',
    link: '/days-matter.html',
    mode: 'all',
    dark: false,
    color_unset: true,
    timestamp: '1671638400000',
  },
  {
    id: 26,
    cover: './assets/food-cal.png',
    tag: '随机图标日历（3种主题',
    link: '/v4/month.html',
    mode: 'all',
    dark: false,
    color_unset: true,
    monday: true,
    theme: [
      {
        key: '',
        label: '水果主题',
        link: '/v4/month.html',
      },
      {
        key: 'drink',
        label: '饮料主题',
        link: '/v4/month_drink.html',
      },
      {
        key: 'food',
        label: '食物主题',
        link: '/v4/month_food.html',
      },
    ],
    timestamp: '1671638400000',
  },
  {
    id: 25,
    cover: './assets/retro-cal.png',
    tag: '中古日历（6种配色',
    link: '/v3/retro-calendar.html',
    mode: 'all',
    dark: false,
    color_unset: true,
    theme: [
      { key: 0, label: '美式复古' },
      { key: 6, label: '美式复古2' },
      { key: 3, label: '港式复古' },
      { key: 4, label: '奶油蓝' },
      { key: 8, label: '奶油粉紫' },
      { key: 2, label: '森系复古绿' },
    ],
    size: 'auto',
    timestamp: '1671638400000',
  },
  {
    id: 24,
    cover: './assets/countdown-k.png',
    tag: '极简倒数日',
    link: '/new/countdown.html',
    mode: 'all',
    dark: false,
    color_unset: true,
    timestamp: '1671638400000',
  },
  {
    id: 22,
    cover: './assets/calendar-moon.png',
    tag: '月相日历',
    link: '/v3/month-moon.html',
    mode: 'all',
    dark: false,
    monday: true,
    font_color: '#333333',
    timestamp: '1658419200000',
  },
  {
    id: 20,
    cover: './assets/seek-month.png',
    tag: '极简日历',
    link: '/v3/month.html',
    mode: 'all',
    dark: false,
    monday: true,
    font_color: '#333333',
    timestamp: '1658419200000',
  },
  {
    id: 19,
    cover: './assets/time_is.png',
    tag: '极简日进度',
    link: '/v3/day.html',
    mode: 'all',
    dark: false,
    font_color: '#333333',
    size: 'auto',
    timestamp: '1658419200000',
  },
  {
    id: 18,
    cover: './assets/clock.png',
    tag: '极简时钟',
    link: '/new/clock2.html',
    mode: 'all',
    dark: false,
    size: 'auto',
    timestamp: '1658419200000',
  },
  {
    id: 17,
    cover: './assets/20220112110301.png',
    tag: '克莱因蓝周日历',
    link: '/new/blue-week.html',
    mode: 'all',
    dark: false,
    monday: true,
    bg_color: '#002fa7',
    font_color: '#ffffff',
    size: 'auto',
    timestamp: '1641916800000',
  },
  {
    id: 16,
    cover: './assets/20220111181002.png',
    tag: '日历卡片',
    link: '/new/calendar_b.html',
    mode: 'light',
    monday: true,
    timestamp: '1641916800000',
    bg_color: '#333',
    font_color: '#fff',
    lng: 'en'
  },
  {
    id: 15,
    cover: './assets/Xnip2022-01-11_11-26-50.jpg',
    tag: '限定周',
    link: '/new/highlight-week.html',
    mode: 'all',
    timestamp: '1641916800000',
  },
  {
    id: 14,
    cover: './assets/20220106152448.png',
    tag: '桌面时钟',
    link: '/new/big-clock.html',
    mode: 'all',
    dark: false,
    timestamp: '1641398400000',
  },
  {
    id: 13,
    cover: './assets/20220106143157.png',
    tag: '人生进度条',
    link: '/new/personal-progress.html',
    timestamp: '1641398400000',
  },
  {
    id: 12,
    cover: './assets/Xnip2022-01-06_12-37-34.jpg',
    tag: '日历卡片',
    link: '/new/calendar.html',
    mode: 'all',
    dark: false,
    monday: true,
    timestamp: '1641398400000',
  },
  {
    id: 11,
    cover: './assets/20220105113554.png',
    tag: '多项倒计时',
    link: '/new/mul-days-matter.html',
    mode: 'all',
    timestamp: '1641312000000',
  },
  {
    id: 10,
    cover: './assets/Xnip2022-01-04_16-02-47.jpg',
    tag: '纵向时间进度条',
    link: '/new/progress-vertical.html',
    mode: 'light',
    dark: false,
    size: 'auto',
    timestamp: '1641225600000',
  },
  {
    id: 9,
    cover: './assets/Xnip2022-01-04_16-02-18.jpg',
    tag: '时间进度条',
    link: '/new/progress.html',
    mode: 'light',
    dark: false,
    timestamp: '1641225600000',
  },
  {
    id: 8,
    cover: './assets/20220104112833.png',
    tag: '周进度',
    link: '/new/week-ceils.html',
    mode: 'light',
    dark: false,
    size: 'auto',
    timestamp: '1641225600000',
  },
  {
    id: 7,
    cover: './assets/20220104111624.png',
    tag: '年度格子',
    link: '/new/year-block.html',
    mode: 'all',
    dark: false,
    timestamp: '1640793600000',
  },
  {
    id: 6,
    cover: './assets/QQ20211230-182424-HD.gif',
    tag: '动画缤纷时钟',
    link: '/colorful-svg-time_w.html',
    timestamp: '1640793600000',
  },
  {
    id: 1,
    cover: './assets/20211230144940.png',
    tag: '进度时钟',
    link: '/progress.html',
    mode: 'light',
    timestamp: '1640793600000',
  },
  {
    id: 2,
    cover: './assets/20211230151833.png',
    tag: '季度进度条',
    link: '/quarterly-progress.html',
    mode: 'light',
    timestamp: '1640793600000',
  },
  {
    id: 3,
    cover: './assets/20211230170132.png',
    tag: '日历',
    link: '/calendar.html',
    mode: 'light',
    dark: false,
    timestamp: '1640793600000',
  },
]

export const effes: LIB_ITEM_TYPE[] = [
  {
    id: 21,
    cover: './assets/tomato.png',
    tag: '极简番茄钟',
    link: '/v3/tomato.html',
    mode: 'all',
    dark: false,
    font_color: '#333333',
    size: 'auto',
    timestamp: '1658419200000',
  },
]

export const others: LIB_ITEM_TYPE[] = [
  {
    id: 1009,
    cover: './assets/wids/widget-1009.png',
    tag: '欢迎卡片',
    link: '/v300/work-card.html',
    mode: 'light',
    tags: '',
    timestamp: '1754117366575',
    bg_color: '#f3f3f3',
    font_color: '#333333',
    lng: 'en'
  },
  {
    id: 1008,
    cover: './assets/wids/widget-1008.png',
    tag: '动态热榜',
    link: '/v300/card-hot.html',
    mode: 'all',
    tags: '限定分享',
    expired: '2024/12/31 23:59',
    timestamp: '1710234868723',
  },
  {
    id: 1007,
    cover: './assets/wids/widget-1007.png',
    tag: '访客欢迎信息',
    link: '/v300/card-simple-2.html',
    mode: 'all',
    tags: '限定分享',
    expired: '2024/12/31 23:59',
    timestamp: '1710234868723',
    bg_color: '#ffffff',
    font_color: '#333333',
  },
  {
    id: 1006,
    cover: './assets/wids/widget-1006.3.png',
    tag: '星座运势',
    link: '/v201/one.html',
    mode: 'all',
    size: 'auto',
    tags: '限时分享',
    expired: '2023/02/05 23:59',
    timestamp: '1675776271295',
    close: true,
    advance: true,
  },
  {
    id: 1005,
    cover: './assets/wids/widget-1005.png',
    tag: 'ONE - 随机句子卡片',
    link: '/v201/one.html',
    mode: 'all',
    size: 'auto',
    desc: '暂不支持背景图片更换',
    tags: '限时分享',
    expired: '2024/12/25 23:59',
    timestamp: '1674835200000',
  },
  {
    id: 1004,
    cover: './assets/tem-btn.png',
    tag: '自定义快捷按钮',
    link: '/v201/my-btns.html',
    icons: [
      { key: 'github', label: 'Github' },
      { key: 'stack-overflow', label: 'Stack Overflow' },
      { key: 'facebook', label: 'Facebook' },
      { key: 'mail', label: 'Mail' },
      { key: 'gmail', label: 'Gmail' },
      { key: 'linkedin', label: 'Linkedin' },
      { key: 'notion', label: 'Notion' },
      { key: 'twitter', label: 'Twitter' },
      { key: 'weibo', label: '微博' },
      { key: 'youtube', label: 'Youtube' },
      { key: 'zoom', label: 'Zoom' },
      { key: 'instagram', label: 'Instagram' },
      { key: 'figma', label: 'Figma' },
    ],
    mode: 'all',
    bg_color: '#ecebe8',
    font_color: '#333333',
    size: 'auto',
    hide: false,
    timestamp: '1673020800000',
  },
  {
    id: 1003,
    cover: './assets/today.jpg',
    tag: '今日诗词',
    link: '/new/today-shici.html',
    theme: [
      { key: 'w', label: '白色卡片' },
      { key: 'b', label: '黑色卡片' },
    ],
    size: 'auto',
    timestamp: '1640880000000',
  },
  {
    id: 1002,
    cover: './assets/20211231103209.png',
    tag: '历史上的今天',
    link: '/new/history-today.html',
    mode: 'all',
    dark: false,
    size: 'auto',
    timestamp: '1640880000000',
  },
  {
    id: 1001,
    cover: './assets/20211230194341.png',
    tag: '乳白引用块',
    link: '/quote.html',
    desc: '『注』：适合短分案，大字体，标题等，引用了特殊字体预览效果可能会有延迟。',
    mode: 'all',
    size: 'auto',
    timestamp: '1640793600000',
  },
  {
    id: 1001.1,
    cover: './assets/refer-1.1.png',
    tag: '边框阴影引用块',
    link: '/quote2.html',
    desc: '『注』：适合繁体，日文和英文文案，中等字体，该字体无法识别部分简体字，引用了特殊字体预览效果可能会有延迟。',
    mode: 'all',
    font_color: '#333333',
    size: 'auto',
    timestamp: '1640793600000',
  },
  {
    id: 1001.2,
    cover: './assets/refer-1.2.png',
    tag: '细文字引用块',
    link: '/quote3.html',
    desc: '『注』：适合繁体，日文和英文文案，中等字体，该字体无法识别部分简体字，引用了特殊字体预览效果可能会有延迟。',
    font_color: '#333333',
    size: 'auto',
    timestamp: '1640793600000',
  },
  {
    id: 1001.3,
    cover: './assets/refer-1.3.png',
    tag: '手写英文引用块',
    link: '/quote-EN.html',
    desc: '注』：仅适用于英文，引用了特殊字体预览效果可能会有延迟。',
    mode: 'all',
    font_color: '#333333',
    size: 'auto',
    timestamp: '1640793600000',
  },
]
